<div
  *ngIf="cs.vm$ | async as vm"
  [ngClass]="{
    'worldpay-form--loading': vm.loading,
    'worldpay-form--iframe-visible': vm.iframeVisible && !vm.loading,
    'worldpay-form--form-visible': !vm.iframeVisible && !vm.loading
  }"
  class="worldpay-form"
>
  <form
    *ngIf="vm.form"
    (submitted)="cs.onFormSubmit($event)"
    [dgxFormDisabled]="vm.purchasing"
    [dgxTestHook]="testHooks.Form"
    [formGroup]="vm.form"
    class="worldpay-form__form"
    dgxFormSubmit
    dgxGaFormSubmit
  >
    <dgx-form-fieldset [dgxFormFieldset]="vm.cmsData.addressFieldset">
      <dgx-form-row [dgxQmSanitise]="'block'">
        <ng-container
          *ngFor="let addressLine of vm.formValue.address | dgxAddressToArray"
        >
          {{ addressLine }}<br />
        </ng-container>
      </dgx-form-row>
    </dgx-form-fieldset>

    <dgx-form-fieldset
      [dgxFormFieldset]="vm.cmsData.billingAddressFieldset"
      class="worldpay-form__address"
    >
      <dgx-form-row>
        <dgx-form-additional-address
          [address]="vm.formValue.address"
          [sameAsAddressCheckboxLabel]="
            vm.cmsData.billingAddressFieldset.billingAddressSameAsAddressField
              .fieldLabel
          "
          formGroupName="billingAddress"
        />
      </dgx-form-row>
    </dgx-form-fieldset>

    <ng-container
      *dgxBasketHasSelectedProductType="
        productType.BoilerCare;
        else applianceCareSection
      "
    >
      <checkout-protection-start-summary-panel
        [body]="vm.cmsData.protectionStartSummaryPanelBodyBoilers"
        [title]="vm.cmsData.protectionStartSummaryPanelTitleBoilers"
      />
    </ng-container>

    <ng-template #applianceCareSection>
      <checkout-protection-start-summary-panel
        [body]="vm.cmsData.protectionStartSummaryPanelBodyWhiteGoods"
        [title]="vm.cmsData.protectionStartSummaryPanelTitleWhiteGoods"
      />
    </ng-template>

    <checkout-terms-and-conditions-fieldset
      *dgxFeatureEnabled="termsAndConditionsFeature"
      [quotes]="vm.selectedQuotes"
      class="worldpay-form__terms-and-conditions"
    />

    <dgx-form-row>
      <dgx-form-submit-button
        [dgxGaClick]="{
          eventAction: 'continue',
          eventLabel: 'continue'
        }"
        class="my-6"
      >
        {{ 'CARD_FORM_SUBMIT' | translate }}
      </dgx-form-submit-button>
    </dgx-form-row>

    <checkout-paperless-preference-fieldset
      *ngIf="vm.cmsData.paperlessPreferenceFieldset as cmsData"
      [dgxFormFieldset]="cmsData"
      [paperlessPreferenceBanner]="cmsData.paperlessPreferenceBanner"
      [paperlessPreferenceField]="cmsData.paperlessPreferenceField"
    />
  </form>

  <div
    [dgxQmSanitise]="'block'"
    [dgxTestHook]="testHooks.WorldpayIframe"
    class="worldpay-form__iframe"
    id="worldpay-form-iframe"
  ></div>

  <dgx-components-loading-overlay
    *ngIf="vm.loading || vm.purchasing"
    @fadeOut
  />
</div>
